// Import Swiper
import Swiper from "swiper";
import { Navigation, FreeMode } from "swiper/modules";

// Make Swiper globally available
Swiper.use([Navigation, FreeMode]);
window.Swiper = Swiper;

// Import GLightbox for video popups
import GLightbox from "glightbox";
window.GLightbox = GLightbox;

// Import utility functions
import "./utilities.js";

// Import modules
import "./header.js";
import "./menu.js";
import "./cart.js";
import "./quantity-selector.js";
import "./size-guide.js";
import "./collection-filter.js";
import "./toggle-filters.js";
import "./customer.js";
import "./buy-again.js";
import "./bab.js";
import "./product-card.js";
import "./search.js";
import "./product-gallery.js";
import "./product-form.js";
import "./video-blog.js";
import { initScrolledLogoSwap } from "./scrolled-logo.js";

document.addEventListener("DOMContentLoaded", () => {
  initScrolledLogoSwap();
});
